import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { TimePicker, Form } from 'antd'

export const TimeStyles = styled(TimePicker)`
  margin-top: 5px;
  width: ${props => (props.width ? props.width : '100%')};
  height: 48px;
  padding: 10px 20px;
  background: ${COLORS.PRIMARY_GREY_T_98};
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 8px;
  line-height: 24px;
  &:focus {
    outline: none;
    opacity: 1;
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
    background-color: ${COLORS.WHITE};
  }
  &:focus::placeholder {
    color: transparent;
  }
  &::placeholder {
    opacity: 0.4;
  }
  &:hover {
    border: 1px solid ${COLORS.GREY_T_90};
  }
  .ant-picker-input > input {
    font-size: 1.1428571428571428em;
    font-weight: 500;
  }
  .ant-btn-primary {
    border-radius: 8px !important;
    height: 38px !important;
  }
`
export const CandidatesDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 10px;
`
export const CandidateCountSpan = styled.span`
  font-weight: ${FONT.FW_700};
`
export const AntdSpan = styled.span`
  margin: 0 3px 0 0;
`
export const CandidateFlex = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  padding-bottom: 29px;
  margin-bottom: 30px;
`
export const CommonDiv = styled.div`
  margin-bottom: 30px;
`
export const TotalTimeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: ${props => (props?.margin ? props?.margin : '8px')};
`
export const ChangeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  cursor: pointer;
  color: #3249D7;
  margin-bottom: ${props => (props?.margin ? props?.margin : '8px')};
`

export const StartSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const SessionFlex = styled(Flex)`
  gap: 20px;
  width: 100%;
`

export const Commondiv = styled.div`
  marging-bottom: ${props => props?.margin};
`

export const CommonFlex = styled(Flex)`
  width: 100%;
  padding-bottom: ${props => props?.margin};
`
export const TimeInfoSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const ModeFlex = styled(Flex)`
  gap: 30px;
`
export const FooterFlex = styled(Flex)`
  gap: 10px;
`
export const CandCountSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 24px;
  color: ${COLORS.GREY_T_40};
  border-radius: 50%;
  border: 1px solid;
  border-style: dashed;
  height: 40px;
  width: 40px;
  padding: 7px 8px;
`
export const ClgFlex = styled(Flex)`
  width: 100%;
  padding: 10px;
  height: 44px;
  background: #fcefed;
  border-radius: 10px;
  gap: 10px;
  margin-top: 10px;
`
export const CollegErrorDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 24px;
  color: ${COLORS.GREY_T_20};
`
export const CollegeSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 24px;
  color: ${COLORS.GREY_T_20};
`

export const FormItem = styled(Form.Item)`
  margin-bottom: ${props => (props?.ismargin ? '0px' : '30px')};
  width: 100%;
`
export const IconWrapper = styled(Flex)`
  margin-bottom: ${props => (props.noBottom ? '0px' : '10px')};
  cursor: pointer;
`

export const TextWrapper = styled(Flex)`
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: #999fac;
  font-size: 10px;
`
export const NoneWrapper = styled(Flex)`
  font-weight: 600;
  font-size: 14px;
  color: #343e59;
  padding-right: 60vh;
`

export const NoneContainer = styled(Flex)`
  padding: 15px;
  cursor: pointer;
`
export const Diveder = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`
export const TimeDivItem = styled.div`
display: flex;
justify-content: space-between;

`
export const TimeDivText = styled.div`
color: rgb(128, 134, 151);
`